module.exports = __webpack_public_path__ + "static/media/fa-solid-900.3d32b39f.woff2";